import { Table } from 'dexie';
import db, { Database } from '@/db';
import { ErrorLogModel } from '../models';

export type TABLE_TYPE = Table<ErrorLogModel>;

export const TABLE = 'errorLog';
const SCHEMA = '++id';

class ErrorLogDatabase {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  write(source: string, message: string) {
    const log = new ErrorLogModel();
    log.source = source;
    log.message = message;
    log.url = window.location.pathname;
    return this.db[TABLE].put(log);
  }

  //when the log hits 100 records, just keep the most recent 50. Not keeping the most recent 100 b/c/ this will result in data churning every time the app starts
  async purge() {
    let list = await this.db[TABLE].toArray();
    if (list.length > 100) {
      list = (await this.db[TABLE].reverse().limit(50).toArray()).reverse();
      await this.db[TABLE].clear();
      await this.db[TABLE].bulkAdd(list);
    }
  }
}

export const ErrorLogDB = new ErrorLogDatabase(db);
